<template>
  <div class="content">
    <div class="not-found">
      <img :src="require('./404_illustration@2x.png')" width="344px" height="323px" alt="404 illustration">
      <div class="inner">
        <span>Page Not Found</span>
        <p class="info">The page you are looking for doesn’t seem to exist…</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    metaInfo: {
      title: 'Page Not Found',
    },
  };
</script>

<style lang="scss" scoped>
.not-found {
  width: 344px;
  margin: 155px auto 15px;
  color: #302c48;
  font-weight: 600;

  .inner {
    width: 260px;
    text-align: center;
    margin-top: -70px;
  }

  span {
    font-size: 20px;
    line-height: 1.2;
  }

  .info {
    opacity: 0.7;
    font-size: 15px;
    line-height: 1.67;
    margin-top: 17px;
  }
}
</style>
